import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  heading: {
    id: 'course-authoring.pages-resources.heading',
    defaultMessage: 'Pages & Resources',
  },
  settings: {
    id: 'course-authoring.pages-resources.resources.settings.button',
    defaultMessage: 'settings',
  },
  viewLiveButton: {
    id: 'course-authoring.pages-resources.viewLive.button',
    defaultMessage: 'View live',
  },
  errorShowingConfiguration: {
    id: 'course-authoring.pages-resources.courseAppPlugin.errorMessage',
    defaultMessage: 'An error occurred when loading the configuration UI for that app.',
  },
  enabled: {
    id: 'course-authoring.badge.enabled',
    defaultMessage: 'Enabled',
  },
  contentPermissions: {
    id: 'course-authoring.pages-resources.content-permissions.heading',
    defaultMessage: 'Content permissions',
  },
});

export default messages;
